module.exports = __webpack_public_path__ + "media/images/version_merge/cmnd_selfie_example-2773fc9aadb9b0be5de052bf8fd82209.jpg";